import { AlertsType } from './types'
import { SAVE_ALERT } from './actionTypes'
import { AlertModel } from '../../../types/alert/alertModel'

const initialState: AlertModel[] = []

const alert = (
	state: AlertModel[] = initialState,
	action: AlertsType
): AlertModel[] => {
	switch (action.type) {
		case SAVE_ALERT: {
			return 'payload' in action ? action.payload : initialState
		}
		default:
			return state
	}
}

export default alert
